const types = {
  GET_USER_NOTIFICATIONS: 'GET_USER_NOTIFICATIONS',
  GET_USER_NOTIFICATIONS_SUCCESS: 'GET_USER_NOTIFICATIONS_SUCCESS',
  GET_USER_NOTIFICATIONS_FAILED: 'GET_USER_NOTIFICATIONS_FAILED',
  REPLY_TO_NOTIFICATION: 'REPLY_TO_NOTIFICATION',
  REPLY_TO_NOTIFICATION_SUCCESS: 'REPLY_TO_NOTIFICATION_SUCCESS',
  REPLY_TO_NOTIFICATION_FAILED: 'REPLY_TO_NOTIFICATION_FAILED',
}

export default types;
